import React, {useEffect} from 'react'
import PropTypes from 'prop-types';
import Page from 'components/Page';
import InfoBar from "components/complex/infobar/InfoBar";
import {makeStyles} from "@material-ui/styles";
import CtrScenesRouter from "./CtrScenesRouter";
import DemandOffersService from "services/DemandOffersService";
import {connect} from "react-redux";
import ContractorStageBar from "components/complex/stagebar/ContractorStageBar";
import Signature from "components/complex/signature/Signature";


const useStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2)
    }
}));

function CtrStepperPages(
    {
        match,
        demandStagesList
    }) {
    const classes = useStyles();

    const demandId = match.params.id;

    useEffect(() => {
        DemandOffersService.getStages(demandId);
        return () => {
            DemandOffersService.clearResources(DemandOffersService.DEMAND_STAGES_LIST);
        }
    }, [demandId])

    return (
        <Page>
            <Signature/>
            <InfoBar contractor/>
            <ContractorStageBar demandStagesList={demandStagesList} contractor/>
            <div className={classes.content}>
                <CtrScenesRouter/>
            </div>
        </Page>
    )
}

CtrStepperPages.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandStagesList: state.resources[DemandOffersService.DEMAND_STAGES_LIST]
}), {})(CtrStepperPages);

